import { Platform } from 'react-native';

export const defaultInitialZoom = Platform.select({
  ios: 12,
  android: 3,
  default: 3.4,
});

export const defaultFocusZoom = Platform.select({
  ios: 6000,
  android: 14,
  default: 12,
});
